import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Yu from '../views/Yu.vue'
import Yuan from '../views/Yuan.vue'
import Yi from '../views/Yi.vue'
import Wen from '../views/Wen.vue'
import Cheng from '../views/Cheng.vue'
import About from '../views/About.vue'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/yu',
    name: 'yu',
    component: Yu
  },
  {
    path: '/yuan',
    name: 'yuan',
    component: Yuan
  },
  {
    path: '/yi',
    name: 'yi',
    component: Yi
  },
  {
    path: '/wen',
    name: 'wen',
    component: Wen
  },
  {
    path: '/cheng',
    name: 'cheng',
    component: Cheng
  },
  {
    path: '/about',
    name: 'about',
    component: About
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果之前有保存滚动位置，则恢复到之前保存的位置
      return savedPosition
    } else {
      // 否则，默认滚动到页面顶部
      return { x: 0, y: 0 }
    }
  }
})

export default router
